var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import AcountContainer from './container/AcountContainer';
import View from '../../elements/View';
import theme from '../../Theme';
import ModuleCollaboratorDetail from './container/ModuleCollaborator';
import { ModuleVirtual } from './container/ModuleVirtual';
import { ModuleEcommerce } from './container/ModuleEcommerce';
import { ModuleApp } from './container/ModuleApp';
import ModuleMarketing from './container/ModuleMarketing';
import ModuleCivitrip from './Civitrip/ModuleCivitrip';
var Index = /** @class */ (function (_super) {
    __extends(Index, _super);
    function Index() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Index.prototype.render = function () {
        return (React.createElement(View, { style: {
                // marginBottom: theme.size.bottomButtons,
                paddingBottom: theme.size.bottomButtons,
                height: '100%',
                overflowY: 'auto',
            } },
            React.createElement(Switch, null,
                React.createElement(Route, { exact: true, path: "/acount", component: AcountContainer }),
                React.createElement(Route, { exact: true, path: "/acount/moduleCollaborator", component: ModuleCollaboratorDetail }),
                React.createElement(Route, { exact: true, path: "/acount/moduleVirtual", component: ModuleVirtual }),
                React.createElement(Route, { exact: true, path: "/acount/moduleEcommerce", component: ModuleEcommerce }),
                React.createElement(Route, { exact: true, path: "/acount/moduleApp", component: ModuleApp }),
                React.createElement(Route, { exact: true, path: "/acount/moduleMarketing", component: ModuleMarketing }),
                React.createElement(Route, { exact: true, path: "/acount/moduleCivitrip", component: ModuleCivitrip }))));
    };
    return Index;
}(Component));
export default Index;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Acount/index.tsx
// module id = 1561
// module chunks = 0